import { css } from "@emotion/react";

import TumblrBlogPosts from "./TumblrBlogPosts";
import { MvtkWidget } from "./";

const News = () => {
  return (
    <div css={mainStyle} id="news">
      <img
        css={roadShowImgStyle}
        src={process.env.REACT_APP_BASE_PATH + "/img/6-21-fri.png"}
      />
      <div css={bannersWrapperStyle}>
        <div>
          <a
            href="https://video.unext.jp/title/SID0157473/"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img
              css={topBannerStyle}
              src={process.env.REACT_APP_BASE_PATH + "/img/UNEXT_pc.png"}
            />
          </a>
        </div>
        <div css={topBannerWrapperStyle}>
          <a
            href="https://kuchinai-sakura.tumblr.com/post/761472152935464960/"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img
              css={topBannerStyle}
              src={process.env.REACT_APP_BASE_PATH + "/img/dvd_banner.jpg"}
            />
          </a>
        </div>
        {/* <MvtkWidget /> */}
        {/*
        <div css={centerBannersWrapperStyle}>
          <a
            href="https://mvtk.jp/Film/085563"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img
              css={centerBannerStyle}
              src={process.env.REACT_APP_BASE_PATH + "/img/mubichike.jpg"}
            />
          </a>
          <a
            href="https://www.major-j.com/cinema_information.php?id=M06453389826"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img
              css={centerBannerStyle}
              src={
                process.env.REACT_APP_BASE_PATH + "/img/mubichike-rakuraku.jpg"
              }
            />
          </a>
        </div>
        */}
        {/*
        <div css={bottomBannerWrapperStyle}>
          <a
            href="https://goods.moviewalker.jp/items/85105393"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img
              css={bottomBannerStyle}
              src={
                process.env.REACT_APP_BASE_PATH + "/img/movie-walker-store.jpg"
              }
            />
          </a>
        </div>
        */}
      </div>
      <div css={gerneWrapperStlye}>
        <img
          css={imgStyle}
          src={process.env.REACT_APP_BASE_PATH + "/img/news-genre-txt.png"}
        />
      </div>
      <div css={titleStyle}>NEWS</div>
      <TumblrBlogPosts />
    </div>
  );
};

const spSize = 768;

const mainStyle = css`
  position: relative;
  width: 100%;
  padding: 40px 0 60px;
  background-size: cover;
  display: flex;
  flex-direction: column;
  align-items: center;

  @media (max-width: ${spSize}px) {
    padding: 30px 0 40px;
  }
`;

const roadShowImgStyle = css`
  width: 100%;
  max-width: 640px;
  height: auto;

  @media (max-width: ${spSize}px) {
    width: 75%;
  }
`;

const bannersWrapperStyle = css`
  width: 720px;
  display: flex;
  flex-direction: column;
  padding: 20px 0;

  @media (max-width: ${spSize}px) {
    width: 85%;
    padding: 20px 0 0;
  }
`;

const topBannerWrapperStyle = css`
  padding-top: 10px;

  @media (max-width: ${spSize}px) {
    padding-top: 0;
  }
`;

const topBannerStyle = css`
  width: 100%;
  height: auto;
`;

const gerneWrapperStlye = css`
  width: 100%;
  display: flex;
  justify-content: center;
  margin-top: 30px;
  padding: 20px 0;
  background-color: rgba(5, 39, 51, 0.9);
`;

const titleStyle = css`
  font-size: 35px;
  font-weight: 500;
  letter-spacing: 0.075em;
  margin-top: 40px;

  @media (max-width: ${spSize}px) {
    font-size: 20px;
    font-weight: 400;
  }
`;

const imgStyle = css`
  width: 100%;
  max-width: 600px;
  height: auto;

  @media (max-width: ${spSize}px) {
    width: 75%;
  }
`;

export default News;
